module.exports = __webpack_public_path__ + "img/pig3.8b9cf093.jpg";